import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'reports'

export const reportService = {
	...getController<Api.Report, Api.ReportPostInput, Api.ReportPutInput>(url),
	async directEmail(
		id: number,
		data: HpRequestPostPut<Api.DirectEmailPostInput>
	) {
		return Service.post({ url: `${url}/${id}/direct_email`, ...data })
	},
	/**
	 * Löscht einen Anhang einer Meldung. Eigene Route statt documentService.delete,
	 * weil Meldungs-Anhänge intern angelegt sind und der generische Endpoint
	 * DELETE /documents/{id} sie nicht findet (404).
	 */
	async deleteDocument(id: number, documentId: number) {
		return Service.delete<unknown>({
			url: `${url}/${id}/documents/${documentId}`,
		})
	},
}

export default reportService
